"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3539],{

/***/ 77208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52494);
/* harmony import */ var _theme_Icons_HorseIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(687);






var Divider = function(_param) {
    var _dividerType = _param.dividerType, dividerType = _dividerType === void 0 ? "default" : _dividerType, side = _param.side, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "dividerType",
        "side"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        mr: "auto",
        marginInlineStart: side === "right" ? "auto" : 0,
        className: "divider",
        layerStyle: "divider_".concat(dividerType),
        pos: "relative"
    }, props), {
        children: (dividerType === "blue_horse" || dividerType === "white_horse") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
            pos: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                fontSize: "3xl",
                as: _theme_Icons_HorseIcon__WEBPACK_IMPORTED_MODULE_1__/* .HorseIcon */ .R,
                color: dividerType === "blue_horse" ? "primary" : "white"
            })
        })
    }));
};


/***/ }),

/***/ 66806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ EnhancedLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);






var EnhancedLink = function(_param) {
    var href = _param.href, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "href",
        "children"
    ]);
    var isExternal = href.startsWith("http");
    var InnerLink = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        as: "a",
        target: isExternal ? "_blank" : undefined,
        href: isExternal ? href : undefined
    }, props), {
        children: children
    }));
    return isExternal ? InnerLink : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        passHref: true,
        children: InnerLink
    });
};


/***/ }),

/***/ 31046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ HTMLText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25935);
/* harmony import */ var _EnhancedLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66806);








var parserOptions = {
    replace: function(domNode) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(domNode, html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .Element */ .W_)) {
            if (domNode.name === "a") {
                var attribs = (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .attributesToProps */ .e_)(domNode.attribs);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_EnhancedLink__WEBPACK_IMPORTED_MODULE_2__/* .EnhancedLink */ .g, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    href: attribs.href
                }, attribs), {
                    children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .domToReact */ .du)(domNode.children, parserOptions)
                }));
            }
        }
    }
};
var HTMLText = function(_param) {
    var text = _param.text, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "text"
    ]);
    var parsedHtml = (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(text, parserOptions);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        __css: {
            p: {
                mb: 4
            },
            "ol, ul": {
                ml: 5
            },
            a: {
                textDecoration: "underline"
            }
        }
    }, props), {
        children: parsedHtml
    }));
};


/***/ }),

/***/ 21097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23887);





var Image = function(_param) {
    var imageStyle = _param.imageStyle, image = _param.image, hideCopyright = _param.hideCopyright, wrapperProps = _param.wrapperProps, description = _param.description, copyrightInside = _param.copyrightInside, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "imageStyle",
        "image",
        "hideCopyright",
        "wrapperProps",
        "description",
        "copyrightInside"
    ]);
    if (!imageStyle) return null;
    var showCopyright = !hideCopyright && image.copyright;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        className: "image-".concat(image.id),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                pos: "relative"
            }, wrapperProps), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Img */ .Ei, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        htmlWidth: imageStyle.width,
                        htmlHeight: imageStyle.height,
                        src: imageStyle.url,
                        width: "100%",
                        loading: "lazy",
                        alt: image.alt || ""
                    }, props)),
                    showCopyright && copyrightInside && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                        pos: "absolute",
                        left: 0,
                        bottom: 0,
                        bg: "rgba(0,0,0, .4)",
                        color: "white",
                        p: 1,
                        fontSize: "xxs",
                        children: [
                            "Foto \xa9 ",
                            image.copyright
                        ]
                    })
                ]
            })),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                pt: 1,
                fontSize: "md",
                children: description
            }),
            showCopyright && !copyrightInside && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                fontSize: "xxs",
                children: [
                    "Foto \xa9 ",
                    image.copyright
                ]
            })
        ]
    });
};


/***/ }),

/***/ 67025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ParagraphRenderer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _config_entity_mapping__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51285);





var getWrapper = function(name, Component) {
    if (name === "container") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            maxW: "container.main",
            children: Component
        });
    } else if (name === "containerSmall") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            maxW: "container.small",
            children: Component
        });
    }
    return Component;
};
var ParagraphRenderer = function(param) {
    var paragraphs = param.paragraphs, wrapperProps = param.wrapperProps, paragraphWrappers = param.paragraphWrappers, getWrapperForParagraph = param.getWrapperForParagraph;
    if (!paragraphs) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        className: "paragraphs",
        children: paragraphs.map(function(paragraph, i) {
            var Component = _config_entity_mapping__WEBPACK_IMPORTED_MODULE_1__/* .EntityMapping */ .f[paragraph.__typename] || null;
            if (!Component) {
                console.warn("[ParagraphRenderer] Paragraph not found", paragraph.__typename);
                return null;
            }
            var InnerComponent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                data: paragraph
            });
            var OuterComponent = InnerComponent;
            if (paragraphWrappers) {
                if (paragraphWrappers[paragraph.__typename]) {
                    OuterComponent = getWrapper(paragraphWrappers[paragraph.__typename], InnerComponent);
                } else if (paragraphWrappers._all) {
                    OuterComponent = getWrapper(paragraphWrappers._all, InnerComponent);
                }
            }
            if (getWrapperForParagraph) {
                var wrapperName = getWrapperForParagraph(paragraph.__typename);
                if (wrapperName) {
                    OuterComponent = getWrapper(wrapperName, InnerComponent);
                }
            }
            if ("contentWidth" in paragraph) {
                if (paragraph.contentWidth === "small") {
                    OuterComponent = getWrapper("containerSmall", InnerComponent);
                }
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                py: 3,
                className: paragraph.__typename,
                pos: "relative",
                __css: {
                    clear: "both"
                }
            }, wrapperProps), {
                children: OuterComponent
            }), "".concat(paragraph.id, "_").concat(i));
        })
    });
};


/***/ }),

/***/ 13539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SectionWithTextImage": function() { return /* reexport */ SectionWithTextImage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var dist_index_esm = __webpack_require__(23887);
// EXTERNAL MODULE: ./src/components/Paragraph/ParagraphRenderer.tsx
var ParagraphRenderer = __webpack_require__(67025);
// EXTERNAL MODULE: ./src/components/Common/HTMLText.tsx
var HTMLText = __webpack_require__(31046);
// EXTERNAL MODULE: ./src/components/Common/Divider.tsx
var Divider = __webpack_require__(77208);
// EXTERNAL MODULE: ./src/components/Common/Image.tsx
var Image = __webpack_require__(21097);
;// CONCATENATED MODULE: ./src/components/Paragraph/SectionWithTextImage/SectionWithTextImage.tsx






var SectionWithTextImage = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        bg: "white",
        pos: "relative",
        __css: {
            ".divider": {
                mx: {
                    base: "auto",
                    md: "0"
                }
            },
            ".section-text-heading": {
                ".text-align-right": {
                    textAlign: {
                        base: "center",
                        md: "right"
                    }
                }
            },
            ".section-text-paragraphs": {
                textAlign: {
                    base: "center",
                    md: "inherit"
                },
                ".text-align-right": {
                    textAlign: {
                        base: "center",
                        md: "right"
                    }
                }
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                maxH: "100%",
                h: "100%",
                objectFit: "cover",
                imageStyle: data.image.imageStyle,
                image: data.image,
                loading: "lazy",
                hideCopyright: true,
                wrapperProps: {
                    pos: "absolute",
                    right: {
                        base: 0,
                        md: data.imagePosition === "right" ? "0" : "50%"
                    },
                    left: {
                        base: 0,
                        md: data.imagePosition === "left" ? "0" : "50%"
                    },
                    bottom: 0,
                    top: 0
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                maxW: "container.main",
                display: "flex",
                justifyContent: data.imagePosition === "right" ? "flex-start" : "flex-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    py: 12,
                    width: {
                        base: "none",
                        md: "50%"
                    },
                    flexDir: "column",
                    justifyContent: "center",
                    pos: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Img */.Ei, {
                            display: {
                                base: "none",
                                md: "block"
                            },
                            pos: "absolute",
                            left: data.imagePosition === "left" ? "auto" : "100%",
                            right: data.imagePosition === "left" ? "100%" : "auto",
                            mr: data.imagePosition === "left" ? "-1px" : 0,
                            top: 0,
                            border: 0,
                            src: "/image_triangle.svg",
                            maxH: "100%",
                            zIndex: 9,
                            transform: data.imagePosition === "left" ? "scaleX(-1)" : "none"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            borderRadius: "md",
                            bg: {
                                base: "rgba(255,255,255,.6)",
                                md: "none"
                            },
                            children: [
                                data.sectionText && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                                    maxW: "container.main",
                                    pt: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLText/* HTMLText */.J, {
                                            className: "section-text-heading",
                                            text: data.sectionText,
                                            wordBreak: "break-word",
                                            textAlign: {
                                                base: "center",
                                                md: "inherit"
                                            }
                                        }),
                                        data.divider && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                                            my: 3,
                                            dividerType: data.divider
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ParagraphRenderer/* ParagraphRenderer */.W, {
                                    paragraphs: data.content,
                                    wrapperProps: {
                                        py: 6,
                                        className: "section-text-paragraphs"
                                    },
                                    paragraphWrappers: {
                                        _all: "container",
                                        ParagraphHero: "none"
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Paragraph/SectionWithTextImage/index.ts



/***/ })

}]);